import { render, staticRenderFns } from "./EditLectorModal.vue?vue&type=template&id=19394b13&scoped=true&"
import script from "./EditLectorModal.vue?vue&type=script&lang=js&"
export * from "./EditLectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19394b13",
  null
  
)

export default component.exports